import { defineStore } from 'pinia';
import { useLocalStorage } from '@vueuse/core';

export const useCalendarEventStore = defineStore({
    id: 'calendarEventStore',
    state: () => ({
        events: useLocalStorage('calEvents', {})
    })
});
